<template>
<div class="chapter">
<div class="inner_page">
<p class="poem3" id="chap2">To remain whole, be twisted.</p>
<p class="poem3">To become straight, let yourself be bent.</p>
<p class="poem3">To become full, be hollow.</p>
<p class="poem3">Be tattered, that you may be renewed.</p>
<p class="poem3">Those that have little, may get more,</p>
<p class="poem3">Those that have much, are but perplexed.</p>
<p class="poem3">The Sage does not show himself, therefore he is seen everywhere.</p>
<p class="poem3">He does not define himself, therefore he is distinct.</p>
<p class="poem3">He does not boast of what he will do, therefore he succeeds.</p>
<p class="poem3">He is not proud of his work, and therefore it endures.</p>
<p class="poem3">He does not contend,</p>
<p class="poem3">And for that very reason no one under heaven can contend with him.</p>
<p class="right" style="margin-top:20px;">—Tao Te Ching</p>
<blockquote>
<p class="noind" style="margin-top:20px;">For by grace are ye saved through faith, and that not of yourselves. It is the gift of God. Not of works, lest any man should boast.</p>
</blockquote>
<p class="right" style="margin-top:20px;">—<i>Ephesians 2</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9chap2.vue?6c938b6a